/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Stuck_TitleInputs */

const en_help_stuck_title = /** @type {(inputs: Help_Stuck_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Still stuck?`)
};

const pl_help_stuck_title = /** @type {(inputs: Help_Stuck_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dalej coś nie gra?`)
};

/**
* | output |
* | --- |
* | "Still stuck?" |
*
* @param {Help_Stuck_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const help_stuck_title = /** @type {((inputs?: Help_Stuck_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Stuck_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_help_stuck_title(inputs)
	return en_help_stuck_title(inputs)
});